<div class="dashboard-accordion-header">
    <mat-accordion>
        <mat-expansion-panel expanded>
            <mat-expansion-panel-header>
                <div class="filters-container" (click)="$event.stopPropagation();">
                    <h3 class="filter-header">Health</h3>
                    <form [formGroup]="form" class="filters">
                        <mat-form-field>
                            <mat-label>Filter by Client</mat-label>
                            <mat-select formControlName="clientName">
                                @for (client of clientNames(); track client) {
                                    <mat-option [value]="client" >{{client}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Filter by Date Range</mat-label>
                            <mat-select formControlName="dateRange">
                                @for (date of dateRanges; track date) {
                                    <mat-option [value]="date.value" >{{date.text}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </form>
                </div>
            </mat-expansion-panel-header>

            <div class="charts">
                <div>
                    @if (healthSummary(); as summary) {
                        <nova-health-glance [values]="summary"/>
                    }
                </div>
                <div>
                    @if (healthOverTime(); as overTime) {
                        <nova-health-over-time [values]="overTime"/>
                    }
                </div>
            </div>
        </mat-expansion-panel>
      </mat-accordion>
</div>
